module.exports = __webpack_public_path__ + "media/images/mobile/abouts/17-567f52fe286dcf5c0b201113d7bef353.png";